import { HasClassName } from '~/types/HasClassName';
import { HasStyle } from '~/types/HasStyle';
import styles from './Skeleton.module.css';
import classNames from 'classnames';

type Props = HasClassName &
  HasStyle & {
    rounding?: 'default' | 'full';
  };

export function Skeleton({ className, style, rounding = 'default' }: Props) {
  return <div className={classNames(styles.skeleton, className, [styles[`rounding-${rounding}`]])} style={style} />;
}
